import { useApplyInvoiceCredit } from "@/api/queries";
import type { CustomerCredit, Invoice } from "@/api/types";
import { UseCreditDialog } from "@/components/UseCreditDialog";
import { formatAmount } from "@/lib/money";

/** Uses a customer's advance, or what a credit note left over, against this invoice. */
export function UseInvoiceCreditDialog({
  invoice,
  credits,
  onClose,
}: {
  invoice: Invoice;
  credits: CustomerCredit[];
  onClose: () => void;
}) {
  const apply = useApplyInvoiceCredit(invoice.id);
  return (
    <UseCreditDialog
      documentNumber={invoice.number}
      documentLabel="invoice"
      description={`${invoice.customerName} owes ${formatAmount(invoice.balance)} on this invoice.`}
      balance={invoice.balance}
      credits={credits.map((credit) => ({
        ...credit,
        kindLabel: credit.kind === "advance" ? "advance" : "credit note",
      }))}
      pending={apply.isPending}
      error={apply.error}
      onUse={(sourceId, amount) =>
        apply.mutate(
          { kind: credits.find((c) => c.sourceId === sourceId)!.kind, sourceId, amount },
          { onSuccess: onClose },
        )
      }
      onClose={onClose}
    />
  );
}
